import { Id } from "@dgs/core";
import { RuleGuestAttributeResourceTypeDataField, RuleResource, RuleTypes } from "../../../shared/types";
import { dataFieldBetween } from "./betweenRule";
import { dataFieldContainsOne } from "./containsOneRule";
import { dataFieldGreaterThanEqual } from "./greaterThanEqualRule";
import { dataFieldHasMaxChars } from "./hasMaxCharsRule";
import { dataFieldHasMinChars } from "./hasMinCharsRule";
import { dataFieldHasNotValue } from "./hasNotValueRule";
import { dataFieldHasValue } from "./hasValueRule";
import { dataFieldIsEmpty } from "./isEmptyRule";
import { dataFieldIsNotEmpty } from "./isNotEmptyRule";
import { dataFieldIsRequired } from "./isRequiredRule";
import { dataFieldLessThanEqual } from "./lessThanEqualRule";
import { dataFieldMustContain } from "./mustContainRule";
import { dataFieldMustNotContain } from "./mustNotContainRule";
import { dataFieldNotContainsOne } from "./notContainsOneRule";
import { dataFieldNotUpdatable } from "./notUpdatableRule";
import { dataFieldReadOnly } from "./readOnlyRule";
import { dataFieldRegex } from "./regexRule";
import { DataFieldRuleValidator, TranslatedErrorProps } from "./types";

const allDataFieldValidations: {
	[K in RuleTypes]: DataFieldRuleValidator;
} = {
	[RuleTypes.IS_REQUIRED]: dataFieldIsRequired,
	[RuleTypes.IS_EMPTY]: dataFieldIsEmpty,
	[RuleTypes.IS_NOT_EMPTY]: dataFieldIsNotEmpty,
	[RuleTypes.NOT_UPDATABLE]: dataFieldNotUpdatable,
	[RuleTypes.READ_ONLY]: dataFieldReadOnly,
	[RuleTypes.HAS_VALUE]: dataFieldHasValue,
	[RuleTypes.HAS_NOT_VALUE]: dataFieldHasNotValue,
	[RuleTypes.HAS_MAX_CHARS]: dataFieldHasMaxChars,
	[RuleTypes.HAS_MIN_CHARS]: dataFieldHasMinChars,
	[RuleTypes.MUST_CONTAIN]: dataFieldMustContain,
	[RuleTypes.MUST_NOT_CONTAIN]: dataFieldMustNotContain,
	[RuleTypes.LESS_THAN_EQUAL]: dataFieldLessThanEqual,
	[RuleTypes.GREATER_THAN_EQUAL]: dataFieldGreaterThanEqual,
	[RuleTypes.CONTAINS_ONE]: dataFieldContainsOne,
	[RuleTypes.NOT_CONTAINS_RULE]: dataFieldNotContainsOne,
	[RuleTypes.REGEX]: dataFieldRegex,
	[RuleTypes.BETWEEN]: dataFieldBetween,
};

export const validateDataField = (
	rule: RuleResource<RuleGuestAttributeResourceTypeDataField>,
	dataFieldValues: Record<Id, any>,
	isImplicitlyRequired: boolean,
): boolean => {
	const key = rule.guestAttribute.dataField.id;
	const desiredValue = rule.guestAttributeReference
		? dataFieldValues[rule.guestAttributeReference.dataField.id]
		: rule.value;
	return allDataFieldValidations[rule.type].validate(
		{ isImplicitlyRequired },
		rule.guestAttribute.dataField.type,
		dataFieldValues[key],
		desiredValue,
	);
};

export const getDataFieldValidationErrorMessage = (
	props: TranslatedErrorProps,
	rule: RuleResource<RuleGuestAttributeResourceTypeDataField>,
	dataFieldValues: Record<Id, any>,
): string => {
	const key = rule.guestAttribute.dataField.id;
	const desiredValue = rule.guestAttributeReference
		? dataFieldValues[rule.guestAttributeReference.dataField.id]
		: rule.value;
	return allDataFieldValidations[rule.type].getErrorMessage(
		props,
		rule.guestAttribute.dataField,
		dataFieldValues[key],
		desiredValue,
	);
};
